export const LOAD_ALL_SURVEYS_REQUEST = "LOAD_ALL_SURVEYS_REQUEST";
export const LOAD_ALL_SURVEYS_SUCCESS = "LOAD_ALL_SURVEYS_SUCCESS";
export const LOAD_ALL_SURVEYS_FAIL = "LOAD_ALL_SURVEYS_FAIL";

export const SURVEY_DETAIL_REQUEST = "SURVEY_DETAIL_REQUEST";
export const SURVEY_DETAIL_SUCCESS = "SURVEY_DETAIL_SUCCESS";
export const SURVEY_DETAIL_FAIL = "SURVEY_DETAIL_FAIL";

export const DELETE_SURVEY_REQUEST = "DELETE_SURVEY_REQUEST";
export const DELETE_SURVEY_SUCCESS = "DELETE_SURVEY_SUCCESS";
export const DELETE_SURVEY_FAIL = "DELETE_SURVEY_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
